import TalkList from '@components/TalkList/TalkList';
import Filters from '@components/Filters/Filters';
import { useEffect } from 'react';
import { useMainContext } from '@contexts/MainContext';
export default function PageHome() {
	const { scrollValue } = useMainContext().state;

	useEffect(() => {
		window.scrollTo(0, parseInt(scrollValue));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<Filters />
			<TalkList />
		</>
	);
}
